<diV class="row" *ngFor="let item of (selectedItems$ | async)">
	<div [ngClass]="fieldClass">
		<div class="input-group">
			<input
				[disabled]="disabled"
				type="text"
				class="form-control"
				[value]="labelGetter(item.entity)"
				readonly />
			<div class="input-group-addon">
				<a class="" href="#" onclick="return false;" title="Retirer" (click)="onDeselectItem(item)">
					<span [ngClass]="'fa fa-minus-circle fa-lg' + (disabled ? ' disabled' : '')"></span>
				</a>
			</div>
		</div>
	</div>
	<ng-container
		[ngTemplateOutlet]="notesTemplate"
		[ngTemplateOutletContext]="{ $implicit: (item.entity) }"
	></ng-container>
</diV>
<div class="row">
	<div [ngClass]="fieldClass" *ngIf="(selectableItems$ | async) as selectableItems">
		<extended-filterable-select *ngIf="!disabled && (showSelect$ | async)"
			[id]="id"
			[disabled]="disabled"
			[inputClass]="'form-control'"
			[selectClass]="'form-control'"
			[list]="selectableItems"
			[labelGetter]="getWrappedItemLabel"
			[categoryList]="categoryList"
			[categoryLabelGetter]="categoryLabelGetter"
			[wildcardCategoryLabel]="wildcardCategoryLabel"
			[categoryChecker]="wrappedItemCategoryChecker"
			[actionIconClass]="'fa-plus-circle'"
			[actionTitle]="''"
			[actionFunction]="doNothing"
			[selectedItem]="selectedItem"
			(selectedItemChange)="onSelectItem($event)"
			>
		</extended-filterable-select>
	</div>
</div>
<div class="row" *ngIf="!disabled && (showAddOrRemoveAll$ | async)">
	<div [ngClass]="['text-center', fieldClass]">
		<a href="#" [ngClass]="(allowAddAll$ | async) ? '' : 'disabled'" onclick="return false;" (click)="onSelectAll()">Tout ajouter</a>
		<span>&nbsp;/&nbsp;</span>
		<a href="#" [ngClass]="(allowRemoveAll$ | async) ? '' : 'disabled'" onclick="return false;" (click)="onDeselectAll()">Tout retirer</a>
	</div>
</div>